import Playground from "./3d/Playground";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <Playground />
    </div>
  );
}
